module.exports = __webpack_public_path__ + "static/media/man.96e88cff.svg";